"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _EditorImage = _interopRequireDefault(require("./components/EditorImage"));
var _plugins = _interopRequireDefault(require("./plugins"));
var _toolbar = _interopRequireDefault(require("./toolbar"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'Tinymce',
  components: {
    editorImage: _EditorImage.default
  },
  props: {
    id: {
      type: String,
      default: function _default() {
        return 'vue-tinymce-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '');
      }
    },
    value: {
      type: String,
      default: ''
    },
    toolbar: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    menubar: {
      type: String,
      default: 'file edit insert view format table'
    },
    height: {
      type: Number,
      required: false,
      default: 400
    },
    sourceType: {
      type: String,
      default: 'dental' // 默认为口腔商品使用本地上传
    }
  },
  data: function data() {
    return {
      hasChange: false,
      hasInit: false,
      tinymceId: this.id,
      fullscreen: false,
      editorActive: true,
      editorInitializing: false,
      editorRetryCount: 0,
      editorGeneration: 0,
      editorMountKey: 0,
      editorDraft: this.value || '',
      languageTypeList: {
        en: 'en',
        zh: 'zh_CN'
      }
    };
  },
  computed: {
    language: function language() {
      // return this.languageTypeList[this.$store.getters.language]
      return this.languageTypeList['zh'];
    }
  },
  watch: {
    value: function value(val) {
      var _this2 = this;
      this.editorDraft = val || '';
      this.$nextTick(function () {
        var editor = _this2.editorInstance;
        if (_this2.editorActive && _this2.hasInit && editor && editor.getContent() !== _this2.editorDraft) {
          editor.setContent(_this2.editorDraft);
        }
      });
    },
    language: function language() {
      this.suspendTinymce();
      this.resumeTinymce();
    }
  },
  mounted: function mounted() {
    this.resumeTinymce();
  },
  activated: function activated() {
    this.resumeTinymce();
  },
  deactivated: function deactivated() {
    this.suspendTinymce();
  },
  beforeDestroy: function beforeDestroy() {
    this.suspendTinymce();
  },
  methods: {
    resumeTinymce: function resumeTinymce() {
      var _this3 = this;
      this.editorActive = true;
      this.editorRetryCount = 0;
      this.$nextTick(function () {
        if (_this3.editorActive && !_this3._isBeingDestroyed && !_this3._isDestroyed) _this3.initTinymce();
      });
    },
    suspendTinymce: function suspendTinymce() {
      this.editorActive = false;
      clearTimeout(this.editorRetryTimer);
      this.editorRetryTimer = null;
      this.editorGeneration++;
      this.destroyTinymce();
      // TinyMCE mutates the textarea's display state; reuse can leave the new
      // iframe hidden/uninitialized after a keep-alive DOM detach/reattach.
      this.editorMountKey++;
      this.tinymceId = this.id + '-mount-' + this.editorMountKey;
    },
    scheduleEditorRetry: function scheduleEditorRetry() {
      var _this4 = this;
      // A permanently detached node or a broken editor script must not poll forever.
      if (!this.editorActive || this.editorRetryCount >= 100) return;
      this.editorRetryCount++;
      this.editorRetryTimer = setTimeout(function () {
        return _this4.initTinymce();
      }, 50);
    },
    initTinymce: function initTinymce() {
      var _this5 = this;
      if (!this.editorActive || this.hasInit || this.editorInitializing) return;
      clearTimeout(this.editorRetryTimer);
      var target = this.$refs.textarea;
      // A cached page can be activated before its transition inserts the DOM.
      // Do not leave initialization pending after a selector finds no element.
      if (!target || !document.documentElement.contains(target)) {
        this.scheduleEditorRetry();
        return;
      }
      this.editorInitializing = true;
      var generation = ++this.editorGeneration;
      var _this = this;
      var initialization = window.tinymce.init({
        language: this.language,
        target: target,
        height: this.height,
        body_class: 'panel-body ',
        object_resizing: false,
        toolbar: this.toolbar.length > 0 ? this.toolbar : _toolbar.default,
        menubar: this.menubar,
        plugins: _plugins.default,
        end_container_on_empty_block: true,
        powerpaste_word_import: 'clean',
        code_dialog_height: 450,
        code_dialog_width: 1000,
        advlist_bullet_styles: 'square',
        advlist_number_styles: 'default',
        imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
        default_link_target: '_blank',
        link_title: false,
        convert_urls: false,
        //防止路径被转化为相对路径
        nonbreaking_force_tab: true,
        // inserting nonbreaking space &nbsp; need Nonbreaking Space Plugin
        init_instance_callback: function init_instance_callback(editor) {
          if (!_this5.editorActive || generation !== _this5.editorGeneration || _this5._isBeingDestroyed || _this5._isDestroyed) {
            editor.remove();
            return;
          }
          editor.setContent(_this5.editorDraft);
          _this5.editorRetryCount = 0;
          _this5.editorInitializing = false;
          _this.hasInit = true;
          editor.on('input NodeChange Change KeyUp SetContent Undo Redo', function () {
            if (!_this5.editorActive || generation !== _this5.editorGeneration) return;
            _this5.hasChange = true;
            _this5.editorDraft = editor.getContent();
            _this5.$emit('input', _this5.editorDraft);
          });
        },
        setup: function setup(editor) {
          if (!_this.editorActive || generation !== _this.editorGeneration) return;
          _this.editorInstance = editor;
          editor.on('FullscreenStateChanged', function (e) {
            if (generation === _this.editorGeneration) _this.fullscreen = e.state;
          });
        }
      });
      if (initialization && typeof initialization.then === 'function') {
        initialization.then(function (editors) {
          if (!_this5.editorActive || generation !== _this5.editorGeneration) return;
          if (!editors.length) {
            _this5.editorInitializing = false;
            _this5.scheduleEditorRetry();
          }
        }, function () {
          if (generation === _this5.editorGeneration) {
            _this5.editorInitializing = false;
            _this5.scheduleEditorRetry();
          }
        });
      }
    },
    destroyTinymce: function destroyTinymce() {
      var tinymce = this.editorInstance;
      this.editorInstance = null;
      this.hasInit = false;
      this.editorInitializing = false;
      if (tinymce && this.fullscreen) {
        tinymce.execCommand('mceFullScreen');
      }
      this.fullscreen = false;
      if (tinymce) {
        tinymce.remove();
      }
    },
    setContent: function setContent(value) {
      this.editorDraft = value || '';
      if (this.hasInit && this.editorInstance) this.editorInstance.setContent(this.editorDraft);
    },
    getContent: function getContent() {
      return this.hasInit && this.editorInstance ? this.editorInstance.getContent() : this.editorDraft;
    },
    imageSuccessCBK: function imageSuccessCBK(arr) {
      var _this6 = this;
      var editor = this.editorInstance;
      if (!this.editorActive || !this.hasInit || !editor) return;
      arr.forEach(function (v) {
        if (_this6.getFileType(v) == 'video') {
          editor.insertContent("<video class=\"wscnph\" src=\"".concat(v, "\" controls muted></video>"));
        } else {
          editor.insertContent("<img class=\"wscnph\" src=\"".concat(v, "\" />"));
        }
      });
    },
    getFileType: function getFileType(fileName) {
      // 后缀获取
      var suffix = '';
      // 获取类型结果
      var result = '';
      try {
        var flieArr = fileName.split('.');
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = '';
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return false;
      }
      suffix = suffix.toLocaleLowerCase();
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      // 进行图片匹配
      result = imglist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'image';
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
      result = videolist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'video';
      }
      // 其他 文件类型
      return 'other';
    }
  }
};